import React from "react"
import ShareSocials from "./shareSocials"
import OptionsAndPrice from "./OptionsAndPrice"

const MenuDetails = ({ details, title }) => {
  const { ongoinMenus, optionPlatSeul, tarifs, typeDeMenu, available } = details
  if (ongoinMenus === null) {
    return null
  }
  const menuDate =
    ongoinMenus[0].date && ongoinMenus[0].date !== null ? (
      <h3 className="h4 text-center mb-1">Menu du {ongoinMenus[0].date}</h3>
    ) : (
      <h3 className="h4 text-center separator mb-1">
        Menu du {ongoinMenus[0].dateDeDebut} au {ongoinMenus[0].dateDeFin}
      </h3>
    )

  const platSeul =
    optionPlatSeul && tarifs.tarifPlatSeul ? (
      <h3 className="h5 text-center">
        Le plat seul à{" "}
        {new Intl.NumberFormat("fr-Fr", {
          style: "currency",
          currency: "EUR",
        }).format(tarifs.tarifPlatSeul)}
      </h3>
    ) : null

  const starters = ongoinMenus[0].starters ? (
    <div className="separator mb-1">
      <h2 className="h4 text-center mb-1">Entrées</h2>
      <div
        className="text-center"
        dangerouslySetInnerHTML={{
          __html: ongoinMenus[0].starters,
        }}
      ></div>
    </div>
  ) : null

  const plats = ongoinMenus[0].plats ? (
    <div className="separator mb-1">
      <h2 className="h4 text-center mb-1">Plats</h2>
      <div
        className="text-center"
        dangerouslySetInnerHTML={{ __html: ongoinMenus[0].plats }}
      ></div>
    </div>
  ) : null

  const desserts = ongoinMenus[0].desserts ? (
    <div className="separator mb-1">
      <h2 className="h4 text-center mb-1">Desserts</h2>
      <div
        className="text-center"
        dangerouslySetInnerHTML={{
          __html: ongoinMenus[0].desserts,
        }}
      ></div>{" "}
    </div>
  ) : null

  const remarques = ongoinMenus[0].remarques ? (
    <div
      className="text-center"
      dangerouslySetInnerHTML={{
        __html: ongoinMenus[0].remarques,
      }}
    ></div>
  ) : null

  return (
    <article className="card--restaurant">
      <div className="card--restaurant__menu bg-black">
        <h2 className="h4 text-center separator">
          Le menu du jour ou la formule du restaurant : {title}
        </h2>
        <OptionsAndPrice prices={tarifs} menuType={typeDeMenu} />
        {platSeul}
        <div className="bg-primary">
          <p className="text-center validity">Valable {available}</p>
        </div>
        {menuDate}
        <div className="card--restaurant__menu__items">
          {starters}
          {plats}
          {desserts}
          {remarques}
        </div>
        <ShareSocials title={`Mes plats du jour | ${title}`} />
      </div>
    </article>
  )
}

export default MenuDetails
